import { render, staticRenderFns } from "./StockInventoryRegradingRecord.vue?vue&type=template&id=3bf1607b&"
import script from "./StockInventoryRegradingRecord.vue?vue&type=script&lang=js&"
export * from "./StockInventoryRegradingRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QItem,QInput,QSelect,QSeparator,QItemSection,QItemLabel,QList,QInnerLoading,QSpinnerGears,QCardActions,QBtn} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QItem,QInput,QSelect,QSeparator,QItemSection,QItemLabel,QList,QInnerLoading,QSpinnerGears,QCardActions,QBtn}, component.options.components || {})
